function SFModal(element) {
  var dom_element = element.get(0);
  if (dom_element.$dynamicSelect) {
    return;
  }
  dom_element.$SFModal = this;
  this.$SFModal = element;
  this._setObjects();
  this._bindEvents();
}

SFModal.prototype._setObjects = function() {
  this.$linkDescription = this.$SFModal.attr("data-sf-modal-link-description");
  this.$SFModalContent = this.$SFModal.find("[data-sf-modal-content]");

  this.$SFModalModal = $("[data-sf-modal-modal]");
  this.$SFModalModalContent = this.$SFModalModal.find("[data-sf-modal-modal-content]");
  this.$SFModalModalOverlay = this.$SFModalModal.find("[data-sf-modal-modal-overlay]");
  this.$body = $("body");
};

SFModal.prototype._bindEvents = function() {
  this.$SFModal.on("click touchstart", $.proxy(this._setAndShow, this));
  this.$SFModalModalOverlay.on("click touchstart", $.proxy(this._hideModal, this));
};

SFModal.prototype._setAndShow = function() {
  this.$SFModalModalContent.html(this.$SFModalContent.html());
  this.$body.addClass("sf-modal--open");
  this.$SFModalModal.fadeIn();

  this.$SFModalClose = this.$SFModalModalContent.find("[data-sf-modal-close]");
  this.$SFModalClose.on("click touchstart", $.proxy(this._hideModal, this));
 
};

SFModal.prototype._hideModal = function() {
  this.$body.removeClass("sf-modal--open");
  //this.$SFModalClose.unbind();
  this.$SFModalModal.fadeOut();
};

$(function() {
  $("[data-sf-modal]").each(function(index, element) {
    new SFModal($(element));
  });
});

